import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
// import BackgroundImage from 'gatsby-background-image';
import { useIntl } from 'gatsby-plugin-react-intl';

import { Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import Container from './theme/Container';
import Typography from './theme/Typography';
import BlockHeadline from './layout/BlockHeadline';
import AppStoreLinks from './AppStoreLinks';
import BgImage from './theme/BgImage';

const query = graphql`
  {
    file(relativePath: { eq: "images/kki-mock_ups.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 90, layout: CONSTRAINED, placeholder: BLURRED, formats: WEBP)
      }
    }
  }
`;

function AppDownload() {
  const {
    file: {
      childImageSharp: { gatsbyImageData },
    },
  } = useStaticQuery(query);
  const intl = useIntl();

  return (
    <BgImage image={gatsbyImageData} sx={(theme) => ({ backgroundColor: theme.palette.grey[800] })}>
      <Box id="App-Download" sx={(theme) => ({ color: theme.palette.common.white, padding: '36px 0 60px' })}>
        <Container>
          <Grid justifyContent="space-between" alignItems="center" spacing={3} container>
            <Grid item xs={12} sm={5} md={6}>
              <Box
                sx={(theme) => ({
                  marginTop: '50px',
                  marginBottom: '50px',
                  [theme.breakpoints.up('md')]: {
                    marginTop: '80px',
                    marginBottom: '80px',
                  },
                  [theme.breakpoints.down('md')]: {
                    marginTop: '0px',
                    marginBottom: '0px',
                  },
                })}
              >
                <BlockHeadline
                  overline={intl.formatMessage({ id: 'appDownload.overline' })}
                  content={intl.formatMessage({ id: 'appDownload.headline' })}
                  variant="h1"
                  sizeRestriction="normal"
                />
                <Typography sx={(theme) => ({ color: theme.palette.common.white })} variant="body1">
                  {intl.formatMessage({ id: 'appDownload.content' })}
                </Typography>
                <AppStoreLinks inline />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </BgImage>
  );
}

export default AppDownload;
